import { createSelector } from 'reselect'
import { fetchingStatusesSelector } from 'selectors/app'

const selectBase = state => state.app

const selectLocationBase = state => state.location

export const selectLastForgotMessage = createSelector(
  selectBase,
  base => (!base.forgotIsSent ? base.forgotLastMessage : '')
)

export const selectLastForgotIsSent = createSelector(
  selectBase,
  base => base.forgotIsSent
)

export const selectChangePasswordRequire2fa = createSelector(
  selectBase,
  base => base.changePasswordRequire2fa
)

export const selectChangePasswordError = createSelector(
  selectBase,
  base => base.latestChangePasswordError
)

export const selectResetPasswordToken = createSelector(
  selectLocationBase,
  base => base.query.reset_password_token
)

export const selectIsValidResetPasswordToken = createSelector(
  selectBase,
  base => !base.changePasswordMissingToken
)

export const selectIsLoadingChangePassword = createSelector(
  fetchingStatusesSelector,
  statuses => statuses.changepassword
)

export const selectIsEcommerce = createSelector(
  selectBase,
  base => base.account?.industry === 'E-Commerce'
)
